module.exports = __webpack_public_path__ + "shell/assets/brand/rgs/dark/rancher-logo.svg";